module.exports = __webpack_public_path__ + "img/weddingrings@2x.7810ab0.jpg";